import Report from "../../../report";
import {ViewType} from "../../../../../gd/const/views/view-type";
import {ReportConfig} from "../../../@types";
import ReportVacationReport_Settings from "./settings";
import SavedView from "../../../../saved-view/saved-view";
import ApiView from "../../../../../gd/api/view";

export default class ReportVacationReport extends Report<ReportVacationReport_Settings> {

    static reportName   : string = "Vacation report"

    constructor(data: ReportConfig) {
        data.type = ViewType.REPORT_VACATION
        super(data);

        this.icon        = "isvg-vacation-report"
        this.name           = data.name || "Time Off Summary"
        this.description    = "Displays the total number of a user's vacations, sick leaves, and other personal events."

        this.settings    = new ReportVacationReport_Settings(data.settings)
    }

    static initFromSavedView(savedView:SavedView): ReportVacationReport {
        return new ReportVacationReport(savedView.toReportConfig())
    }

    //Xotel dobavit po vishe. No tut raznie settings. Instance budet otlichatsya
    async getView(){
        try{
            const response = await ApiView.getView(this.id).promise()

            this.savedView = SavedView.initFromJson(response)
            //Set settings from saved view.
            this.settings  = new ReportVacationReport_Settings(this.savedView.data.settings)
        }
        catch(e){
            console.error(e)
        }
    }

}
